export default __webpack_public_path__ + "media/src/assets/images/trailer_1-279c82d59576edace4f3322bf7b08750.svg";